/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  router.config.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import customerRouter from '@/config/customer'
import orderRouter from '@/config/order'
import mallRouter from '@/config/mall'
import commodityRouter from '@/config/commodity'
import shareRouter from '@/config/share'
import contractRouter from '@/config/contract'
import rolesRouter from '@/config/roles'
import dataReportRouter from '@/config/dataReport'
import homesRouter from '@/config/homes'
import financialRouter from '@/config/financial'
import informationRouter from '@/config/information'
import approve from '@/config/approve'
import guaranteeRouter from '@/config/guarantee'
import industryMallRouter from '@/config/industryMall'
import loginRouter from '@/config/login'
import storeRouter from '@/config/store'
import jielongRouter from '@/config/jielong'
// import marketActivityRouter from '@/config/marketActivity'

export const constantRouterMap = [
    {
      path: "/messageDetail",
      name: "MessageDetail",
      component: () =>
              import(/* webpackChunkName: "login" */ "@/views/company/template/MessageDetail.vue"),
      meta: {
        title: "公告详情",
        deepth: 2
      },
    },
    {
        path: '/chooseCompany',
        name: 'ChooseCompany',
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/company/ChooseCompany.vue'),
        meta: {
            title: '切换公司',
            deepth: 1
        },
    },
    {
        path: '/unbind',
        name: 'Unbind',
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/company/Unbind.vue'),
        meta: {
            title: '解除绑定',
            deepth: 3
        },
    },
    {
        path: '/createCompany',
        name: 'CreateCompany',
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/company/CreateCompany.vue'),
        meta: {
            title: '创建公司',
            deepth: 2
        },
    },
    {
        path: '/companyMsgDetail',
        name: 'CompanyMsgDetail',
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/company/CompanyMsgDetail.vue'),
        meta: {
            title: '公司信息',
            deepth: 1,
            permission: true
        },
    },
    {
      path: '/version',
      name: 'Version',
      component: () =>
              import(/* webpackChunkName: "login" */ '@/views/company/Version.vue'),
      meta: {
        title: '版本管理',
        deepth: 1,
        permission: false
      },
    },
    {
      path: '/addVersion',
      name: 'AddVersion',
      component: () =>
              import(/* webpackChunkName: "login" */ '@/views/company/addVersion.vue'),
      meta: {
        title: '邀请码',
        deepth: 1,
        permission: false
      },
    },
    {
      path: '/addVersionCode',
      name: 'AddVersionCode',
      component: () =>
              import(/* webpackChunkName: "login" */ '@/views/company/addVersion.vue'),
      meta: {
        title: '版本邀请码',
        deepth: 1,
        permission: false
      },
    },
    {
        path: '/500',
        component: () =>
            import(/* webpackChunkName: "exception" */ '@/views/exception/500.vue'),
        meta: {
            title: '500',
            deepth: 6
        }
    },
    {
        path: '/addressMap',
        name: 'AddressMap',
        component: () =>
            import(/* webpackChunkName: "addressMap" */ '@/views/addressMap/index.vue'),
        meta: {
            title: '选择地址',
            deepth: 2
        }
    },
    {
        path: '/jieLongOrder',
        name: 'JieLongOrder',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/jielongOrder/jielongOrder.vue'),
        meta: {
            title: '订单管理',
            deepth: 1
        }
    },
    {
        path: '/batchOrder',
        name: 'BatchOrder',
        component: () =>
            import(/* webpackChunkName: "jielong" */ '@/views/batchOrder/batchOrder.vue'),
        meta: {
            title: '批量处理',
            deepth: 2
        }
    },
    ...customerRouter,
    ...orderRouter,
    ...mallRouter,
    ...commodityRouter,
    ...shareRouter,
    ...contractRouter,
    ...rolesRouter,
    ...dataReportRouter,
    ...homesRouter,
    ...financialRouter,
    ...informationRouter,
    ...approve,
    ...guaranteeRouter,
    ...industryMallRouter,
    ...loginRouter,
    ...storeRouter,
    ...jielongRouter,
    // ...marketActivityRouter,
    {
        path: '*',
        component: () =>
            import(/* webpackChunkName: "exception" */ '@/views/exception/404.vue'),
        meta: {
            title: '404',
            deepth: 6
        },
    },
]

/**
 * 基础路由
 * @type { *[] }
 */
export const asyncRouterMap = []
